import { Dialog, DialogContent } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import {
  TViewDetailsModalContentProps,
  ViewDetailsModalContent,
} from './ViewDetailsModalContent';

export const ViewDetailsModal = ({
  isOpen,
  onClose,
  className,
  ...props
}: TViewDetailsModalContentProps & {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className={cn('w-full max-w-[400px]', className)}>
        <ViewDetailsModalContent {...props} />
      </DialogContent>
    </Dialog>
  );
};
